(function ($) {
  Drupal.behaviors.offersVip = {
    attach: function (context) {
      var $container = $('.offers-vip', context);
      var $description = $('.offers-vip__description', context);
      var $image = $('.offers-vip__image', context);

      // keep image at bottom of page on pc
      function sizeCheck() {
        $container.removeClass('offers-vip--sized');
        var dHeight = $description.height() + parseInt($description.css('padding-top')) + parseInt($description.css('padding-bottom'));
        // outerheight broken returning object, mismatch of jquery and jquery UI
        var iHeight = $image.height();

        if (dHeight > iHeight) {
          $container.addClass('offers-vip--sized');
        }
      }

      var currentBreakpoint = Unison.fetch.now().name;

      if (currentBreakpoint != 'small') {
        sizeCheck();
        var updateLayout = _.debounce(function (e) {
          sizeCheck();
        }, 100);

        window.addEventListener('resize', updateLayout, false);
      }
    }
  };
})(jQuery);
